var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1318 15L22.2985 2.16663V9.49996H3.5985C3.08512 9.49996 2.82843 9.49996 2.63234 9.59987C2.45986 9.68775 2.31963 9.82799 2.23175 10.0005C2.13184 10.1966 2.13184 10.4532 2.13184 10.9666V19.0333C2.13184 19.5467 2.13184 19.8034 2.23175 19.9995C2.31963 20.1719 2.45986 20.3122 2.63234 20.4C2.82843 20.5 3.08512 20.5 3.5985 20.5H22.2985V27.8333L35.1318 15Z",
    stroke: "#5A52C3",
    strokeWidth: 2.89474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.32af18d9d269c7e4a822ddd44ada1d11.svg";
export { ForwardRef as ReactComponent };